import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { flatten, forEach, map } from '@beef/utils';
/**
 * Convert prop from flexible array format to raw value
 */
export var NodeTreeProjection = /*#__PURE__*/function () {
  function NodeTreeProjection(nodes) {
    _classCallCheck(this, NodeTreeProjection);
    this.nodes = nodes;
  }

  // TODO: children поля могут потребовать дополнительных данных при параметризации
  _createClass(NodeTreeProjection, [{
    key: "getRootNodeIds",
    value: function getRootNodeIds(ctx) {
      var parentIds = {};
      forEach(this.nodes, function (node, nodeId) {
        // схлопываем children-поля, нас не интересует к какой группе относится узел, важно, что он есть
        flatten(Object.values(node.children.evaluate(ctx))).forEach(function (childId) {
          parentIds[childId] = nodeId;
        });
      });
      return Object.keys(this.nodes).filter(function (nodeId) {
        return !parentIds[nodeId];
      });
    }

    // FIXME: данный метод не нужен и перестанет работать в продуктиве, но сейчас используется в тестах.
    //  По сути вместо подсчета дерева, для вычисления структуры нужно проходить
    //  по дереву от корневых узлов, а не случайным образом по всем
  }, {
    key: "evaluate",
    value: function evaluate(ctx) {
      return map(this.nodes, function (node) {
        return node.evaluate(ctx);
      });
    }
  }]);
  return NodeTreeProjection;
}();

// Задача: Определить корневой узел, с которого нужно начинать рендеринг
//
// Корневой узел: узел, который в текущем контексте не является потомком ни одного другого узла
//
// Принятые ограничения:
// 1. children-поля не могут зависеть напрямую от маппинга.
// Причины такого выбора две:
// - Во-первых, если children-поля зависят от маппинга, то и родители подчиняются маппингу.
//   В результате возможна ситуация, при которой невозможно получить корневые узлы, без проверки гипотез.
// - Во-вторых, невозможно понятным образом визуализировать структуру пользователю (разработчику),
//   если дерево меняется на этапе исполнения.
//
// Возможные зависимости:
// 1. статические параметры - size, lang
// 2. (to be) параметризация (группы параметров задаются статически и вычисляются посредством маппинга
//    ещё до рендеринга дерева)